import { render } from "./SemillerosView.vue?vue&type=template&id=7dd95c4c&scoped=true"
import script from "./SemillerosView.vue?vue&type=script&lang=js"
export * from "./SemillerosView.vue?vue&type=script&lang=js"

import "./SemillerosView.vue?vue&type=style&index=0&id=7dd95c4c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd95c4c"]])

export default __exports__